import adminRequest from '../../../config/adminRequest';
import { UsdtUri } from '../../core/configs/services';
import { AdminResponse } from '../models/adminResponse';

export type CReceiverType = 'payout' | 'collect' | 'payout_c2';

export type CReceiver = {
  id: number;
  type: CReceiverType;
  address: string;
  enabled: boolean;
  orderIndex: number;
  supplier?: string;
  createdBy?: string;
  createdAt?: string;
};

/** 出款C游標 per-wallet:每顆出款錢包各輪各的環(key 綁地址,存 poke-jobs Redis)。 */
export type CCursorStatus = {
  ringSize: number;
  wallets: {
    address: string;
    cursor: number;
    /** 下一筆會輪到環的第幾個(0-based);環是空的時候 null。後端算,面板不心算取模。 */
    nextIndex: number | null;
    nextAddress: string | null;
  }[];
};

/** 供應商(供能池)選項:值=地址(後端白名單驗證),顯示用代號。 */
export const C_SUPPLIERS = [
  { code: 'A', address: 'TYAzzycMgo1s1f6fdAP48Bhbf2Z55ghtqa' },
  { code: 'B', address: 'TWmiAUigTkcnbhpg3DpQyW2QEbkC58kdWp' },
  { code: 'C', address: 'TT3EDfsk4AfumVQ9mVXkx4BXpwQx3cu2dy' },
];
export const DEFAULT_SUPPLIER = C_SUPPLIERS[0].address;
export const supplierCode = (address?: string) =>
  C_SUPPLIERS.find((s) => s.address === address)?.code ?? '?';

export class CReceiverProvider {
  static async list(type: CReceiverType): Promise<CReceiver[]> {
    const res = await adminRequest.get<AdminResponse<CReceiver[]>>(
      UsdtUri(`/admin/c-receiver?type=${type}`),
    );
    return res.data.data;
  }

  static async add(input: {
    type: CReceiverType;
    address: string;
    orderIndex?: number;
    supplier?: string;
  }): Promise<CReceiver> {
    const res = await adminRequest.post<AdminResponse<CReceiver>>(UsdtUri('/admin/c-receiver'), input);
    return res.data.data;
  }

  static async update(
    id: number,
    patch: { enabled?: boolean; orderIndex?: number; supplier?: string },
  ): Promise<void> {
    await adminRequest.patch(UsdtUri(`/admin/c-receiver/${id}`), patch);
  }

  static async cursorStatus(): Promise<CCursorStatus> {
    const res = await adminRequest.get<AdminResponse<CCursorStatus>>(
      UsdtUri('/admin/c-receiver/payout-cursor'),
    );
    return res.data.data;
  }

  static async cursorSet(address: string, cursor: number): Promise<void> {
    await adminRequest.post(UsdtUri('/admin/c-receiver/payout-cursor'), { address, cursor });
  }

  static async remove(id: number): Promise<void> {
    await adminRequest.delete(UsdtUri(`/admin/c-receiver/${id}`));
  }
}
